module.exports = __webpack_public_path__ + "img/cobalt_lounge.jpg";